import axios from 'axios';
import jwtInterceptor from './jwtInterceptor';
import errorInterceptor from './errorInterceptor';

/**
 * Condivisione pubblica di un task (snapshot) sul backend statistiche Python.
 * BaseURL `${REACT_APP_STATS_BACKEND_BASE_URI}/tasks` (…/helpers/tasks):
 * `POST /tasks/{idprocesstoken}/share` autenticata.
 *
 * Il GET pubblico `/tasks/shared/{hash}` NON passa da qui: la pagina
 * `SharedTaskPage` usa axios grezzo, perché questi interceptor aggiungono il
 * JWT e — soprattutto — l'errorInterceptor fa scattare il logout globale su
 * ogni 401/404, che su una pagina pubblica sarebbe un disastro.
 */
const instance = axios.create({
    baseURL: `${process.env.REACT_APP_STATS_BACKEND_BASE_URI}/tasks`,
    headers: {
        "Content-Type": "application/json"
    }
});

instance.interceptors.request.use(jwtInterceptor);
instance.interceptors.response.use(undefined, errorInterceptor);

export default instance;
